export enum HlPercentageTypeEnum{
    RM = 'RM',
    Grading = 'Grading'
}